import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import DriversPowerSelect from '../drivers/drivers-power-select.jsx';
import "react-month-picker-calendar/dist/react-month-picker-input.css";

export default class DriverDamagesReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:false,
            url:'/api/v1/portal/portal-admin/driver-damages-report/',
            downloadUrl:'/api/v1/portal/portal-admin/download-total-jobs-raised-by-user-report/',
            totalDamages:[],
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            filename:'Driver Damages Report',
            isDownloading:false,
            driver_id:null,
            selectedDriver:null
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        // this.handleDriverSelection = this.handleDriverSelection.bind(this);
    }
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    // handleDriverSelection(selectedOption) {
    //     this.setState({driver_id: selectedOption.driver_id,selectedDriver:selectedOption.full_name});
    // }
    handleTotalJobsRaisedByUserReportGenerate(e) {
        this.setState({isLoading: true});
        let url = this.state.url+moment(this.state.startDate).format("YYYY-MM-DD")+'/'+moment(this.state.endDate).format("YYYY-MM-DD");

        return fetch(url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
              //console.log(response.users);  
              this.setState({
                totalDamages: response.damages,
                isLoading: false
              })
            });
          }).catch(err=>{
            alert('sorry something went wrong.') ;
        });
    }

    downloadableCsvData(filename,text){
        this.setState({isDownloading: true});
        let filenamed = filename+" FROM "+moment(this.state.startDate).format("YYYY-MM-DD")+" TO "+moment(this.state.endDate).format("YYYY-MM-DD")+".csv";
        let textdata = "DATE,AMOUNT,TYPE,DESCRIPTION\n"+text;
        let element = document.createElement('a');
        element.setAttribute('href','data:text/plain;charset=utf-8,' + encodeURIComponent(textdata));
        element.setAttribute('download', filenamed);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        this.setState({isDownloading: false});
    }
    render() {
        let totalDamages = [];
        let downloadCsvData = [];
        if(this.state.totalDamages.length > 0){
            let totalAmount = 0.00;
            this.state.totalDamages.map((driver, index) => {
                if(driver.damages && driver.damages.length > 0){
                    totalDamages.push(
                        <tr key={index}>
                            <td className="job-ref-font16" colSpan="4"><b>{driver.name}</b></td>
                        </tr>
                    );
                    downloadCsvData = downloadCsvData +
                                            driver.name+','+
                                            ""+','+
                                            ""+','+
                                            ""+"\n";
                    driver.damages.map((damage, index) => {
                        totalDamages.push(
                            <tr key={index+'-damages'+damage.id}>
                                <td className="job-ref-font16">{moment(damage.start_date).format("YYYY-MM-DD")}</td>
                                <td>&pound;{ damage.original_amount_to_repay}</td> 
                                <td>{damage.type}</td>        
                                <td>{damage.description}</td>
                            </tr>
                        );
                        totalAmount = parseFloat(totalAmount) + (parseFloat(damage.original_amount_to_repay));
                        downloadCsvData = downloadCsvData +
                                            moment(damage.start_date).format("YYYY-MM-DD")+','+
                                            damage.original_amount_to_repay+','+
                                            damage.type+','+
                                            damage.description+"\n";
                    });
                    
                
                }
                
                
            });
            totalDamages.push(
                <tr key="last-total-row">
                    <td className="job-ref-font16">Total</td>
                    <td colSpan="3">&pound;{parseFloat(totalAmount).toFixed(2)}</td>        
                </tr>
            );
        }else{
            totalDamages.push(
               <tr key='no-records'><td colSpan="6" className='text-center'>No Records</td></tr>
            );
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <h2>Driver Damages Report</h2>
                    <br/><br/><br/>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        Select From Date:
                    </div>
                    <div className="col-md-2">
                       Select To Date:
                    </div>
                    {/* <div className="col-md-2">
                        Select Driver:
                    </div> */}
                </div>
                <div className="row">
                    <div className="col-md-2">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-2">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate}/>
                    </div>
                    {/* <div className="col-md-3 col-sm-12">
                        <DriversPowerSelect
                            handleDriverSelection={this.handleDriverSelection}
                        />
                    </div> */}
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-success btn-lg" disabled={this.state.isLoading ? true:false} onClick={(e) => this.handleTotalJobsRaisedByUserReportGenerate(e)}>
                                <i className="fa fa-download"></i> Generate Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg" disabled={this.state.isDownloading ? true:false} onClick={(e) => {this.downloadableCsvData(this.state.filename,downloadCsvData)}}>
                                <i className="fa fa-download"></i> Download Report {this.state.isDownloading ? <i className="fa fa-spinner fa-pulse"></i> : ''}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-10 col-sm-10">
                        {/* <h4 className="alert alert-info text-center">{(this.state.totalDamages.length > 0 ? this.state.totalDamages.length : this.state.totalDamages.length)} damages found..</h4> */}
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                                <thead className="sticky-top-without-zindex bg-light">
                                   <tr>
                                        <th>Date</th>
                                        <th>Amount</th>
                                        <th>Type</th>
                                        <th>Description</th>
                                   </tr>
                                </thead> 
                                <tbody>
                                    {this.state.isLoading ? (<tr><td colSpan="6"><span className="add-loading-text"><i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :totalDamages}
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-driver_damages_report')) {
    ReactDOM.render(
        <DriverDamagesReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-driver_damages_report')
    );
}
